<script setup></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <g clip-path="url(#clip0_8928_276)">
      <path
        d="M12 7.77175C9.60001 7.77175 7.70001 9.77175 7.70001 12.1718C7.70001 14.6718 9.60001 16.5718 12 16.5718C14.4 16.5718 16.3 14.5718 16.3 12.1718C16.3 9.67175 14.4 7.77175 12 7.77175ZM12 14.5718C10.7 14.5718 9.70001 13.4718 9.70001 12.1718C9.70001 10.8718 10.7 9.77175 12 9.77175C13.3 9.77175 14.3 10.8718 14.3 12.1718C14.3 13.4718 13.3 14.5718 12 14.5718ZM23.9 11.6718C23.7 11.2718 19.1 3.17175 12 3.17175C4.90001 3.17175 0.300012 11.2718 0.100012 11.6718C-0.0999878 11.9718 -0.0999878 12.3718 0.100012 12.6718C0.300012 13.0718 4.90001 21.1718 12 21.1718C19.1 21.1718 23.7 13.0718 23.9 12.6718C24 12.3718 24 11.9718 23.9 11.6718ZM12 19.0718C7.00001 19.0718 3.30001 13.8718 2.20001 12.1718C3.20001 10.4718 7.00001 5.27175 12 5.27175C17 5.27175 20.7 10.4718 21.8 12.1718C20.8 13.8718 17 19.0718 12 19.0718Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_8928_276">
        <rect width="24" height="24" fill="white" transform="translate(0 0.171753)" />
      </clipPath>
    </defs>
  </svg>
</template>
